import { Provider } from '@orbita-ui/core';
import { ConfigProvider } from 'antd';
import esES from 'antd/locale/es_ES';
import { KeycloakProvider } from './auth/keycloak';
import ErrorFallback from './components/error-fallback';
import GlobalStyle from './components/global-styles';
import { AppContextProvider } from './context/appContext';
import { ToastContextProvider } from './context/toastContext';
import dayjs from 'dayjs';
import 'dayjs/locale/es';
import React from 'react';
import * as ReactDOMClient from 'react-dom/client';
import { ErrorBoundary } from 'react-error-boundary';
import { BrowserRouter } from 'react-router-dom';
import Routes from './routes';
import { LoadingProvider } from './context/LoadingContext';
dayjs.locale('es');

function prepare() {
  /*
  * for use mocks:
  if (process.env.NODE_ENV === 'development') {
  */
  if (process.env.NODE_ENV === 'mock') {
    const { worker } = require('./mocks');
    return worker.start();
  } else {
    return Promise.resolve();
  }
}

const App = () => (
  <KeycloakProvider>
    <ConfigProvider
      locale={esES}
      theme={{
        token: {
          colorPrimary: '#a368fc',
          colorInfo: '#a368fc',
        },
      }}
    >
      <BrowserRouter>
        <ErrorBoundary FallbackComponent={ErrorFallback}>
          <AppContextProvider>
            <LoadingProvider>
              <Provider variant="theme-di">
                <GlobalStyle />
                <ToastContextProvider>
                  <Routes />
                </ToastContextProvider>
              </Provider>
            </LoadingProvider>
          </AppContextProvider>
        </ErrorBoundary>
      </BrowserRouter>
    </ConfigProvider>
  </KeycloakProvider>
);

const container = document.getElementById('root');
const root = ReactDOMClient.createRoot(container);

prepare().then(() => {
  root.render(<App />);
});
